module.exports = __webpack_public_path__ + "static/media/vector-white.ba249a37.svg";